import AffiliationsInfoContent from './AffiliationsInfoContent';

export default AffiliationsInfoContent;
